import { APITagType } from './invisibly-api.types';

const {
  BrandOffer, Company, InsertionOrder, InvoiceGroup, MagazineTitle, PacingView, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, PulsePollingConfig, OrganizationClients,
} = APITagType;

export const ALL_API_TAG_TYPES: APITagType[] = [BrandOffer, Company, InsertionOrder, InvoiceGroup, MagazineTitle, PacingView, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, PulsePollingConfig, OrganizationClients];
